<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Family Portraits</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/Text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/Text/ch002#about-the-book">About the Book</a></li>
<li id="toc-li-3"><a href="#/Text/ch003#copyright-information">Copyright Information</a></li>
<li id="toc-li-4"><a href="#/Text/ch004#the-gallaghers">The Gallaghers</a></li>
<li id="toc-li-5"><span href="#/Text/ch005#the-campbells" title="Link target outside of Sample">The Campbells</span></li>
<li id="toc-li-6"><span href="#/Text/ch006#the-gallaghers-and-the-campbells" title="Link target outside of Sample">The Gallaghers and the Campbells</span></li>
<li id="toc-li-7"><span href="#/Text/ch007#gallagher-gabriel-finnegan" title="Link target outside of Sample">Gallagher, Gabriel Finnegan</span></li>
<li id="toc-li-8"><span href="#/Text/ch008#gabriels-miracles" title="Link target outside of Sample">Gabriel’s Miracles</span></li>
<li id="toc-li-9"><span href="#/Text/ch009#epilogue" title="Link target outside of Sample">Epilogue</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?3d364b1d